import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { getRansomwareInfo } from '@/lib/api/ransomware';

type Stat = number | null;

export function RansomwareStats() {
  // null means "not loaded / unavailable" and renders as a dash. Using 0 here
  // was why a failed fetch looked like a real count of zero.
  const [stats, setStats] = useState<{ groups: Stat; victims: Stat }>({
    groups: null,
    victims: null,
  });

  useEffect(() => {
    async function fetchStats() {
      try {
        const info = await getRansomwareInfo();

        // Upstream moved from { Groups: { Numbers } } to a flat { groups }.
        setStats({
          groups: info.groups ?? info.Groups?.Numbers ?? null,
          victims: info.victims ?? info.Victims?.Numbers ?? null,
        });
      } catch (error) {
        console.error('Error fetching ransomware stats:', error);
      }
    }

    fetchStats();
  }, []);

  const format = (value: Stat) =>
    value === null ? '—' : value.toLocaleString();

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium w-full text-center">Ransomware Groups Tracked</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-center">{format(stats.groups)}</div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium w-full text-center">Victims</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-center">{format(stats.victims)}</div>
        </CardContent>
      </Card>
    </div>
  );
}
